// src/lib/rbac/pickHighestAdminRole.ts

import { ADMIN_ROLE_PRIORITY, type RoleType } from './roles';

/**
 * Return the user's role if it is an admin role, else null. The name
 * predates the one-role-per-user refactor (a690359) when users could
 * hold multiple admin roles and we picked the highest. Now it's just a
 * narrow predicate, but kept under the same name to avoid churn.
 *
 * Used by authProvider to decide the login redirect surface.
 */
export function pickHighestAdminRole(role: RoleType | null): RoleType | null {
  if (role === null) return null;
  return ADMIN_ROLE_PRIORITY.includes(role) ? role : null;
}
